import { useEffect, useState } from "react";
import { lineHeightDisplayString, parseLineHeightInput, type TextLineHeight } from "@/document/model/text";
import { ScrubField } from "./ScrubField";
import { ScrubInput } from "./ScrubInput";

export function LineHeightField({
  lineHeight,
  fontSize,
  onCommit,
}: {
  lineHeight: TextLineHeight | "mixed";
  fontSize: number;
  onCommit: (lineHeight: TextLineHeight) => void;
}) {
  const mixed = lineHeight === "mixed";
  const committed = mixed ? "Mixed" : lineHeightDisplayString({ fontSize, lineHeight });
  const [draft, setDraft] = useState(committed);

  useEffect(() => {
    setDraft(committed);
  }, [committed]);

  function commit(nextDraft = draft): void {
    const parsed = parseLineHeightInput(nextDraft);
    if (parsed) {
      onCommit(parsed);
      setDraft(lineHeightDisplayString({ fontSize, lineHeight: parsed }));
      return;
    }

    if (mixed) {
      setDraft(committed);
    }
  }

  return (
    <ScrubField label="Line" scrubbable={false}>
      <ScrubInput
        type="text"
        value={draft}
        onChange={event => setDraft(event.target.value)}
        onBlur={() => commit()}
        onKeyDown={event => {
          if (event.key === "Enter") {
            event.preventDefault();
            commit();
            event.currentTarget.blur();
          }
          if (event.key === "Escape") {
            event.preventDefault();
            setDraft(committed);
            event.currentTarget.blur();
          }
        }}
        className={mixed ? "text-slate-400" : undefined}
      />
    </ScrubField>
  );
}
